




















































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { storePenunjang } from "@/store/modules/penunjang";
import DetailPenunjangLain from "@/components/pemeriksaan/penunjang/DetailPenunjangLain.vue";
import moment from "moment";
import PdfPenunjang from "@/components/pemeriksaan/penunjang/Pdf.vue";
import ZoomModal from "@/components/pemeriksaan/penunjang/ZoomModal.vue";
import ConfirmDialog from "@/components/modal/ConfirmDialog.vue";

interface PenunjangLainItem {
  catatan: string;
  dokter: {
    id: number | string;
    nama: string;
  };
  file: Array<object>;
  id: number;
  pasien: {
    rm: string;
    nama: string;
  };
  penunjang_lain_kategori: {
    id: number | string;
    nama: string;
  };
  kb_metode_kode: number | null;
  kb_metode_nama: string | null;
  register_id: number | string;
  tanggal: string;
  unit: {
    id: number | string;
    nama: string;
  };
  user: {
    id: number | string;
    nama: string;
  };
  waktu_periksa: string;
}

@Component({
  components: {
    DetailPenunjangLain,
    PdfPenunjang,
    ZoomModal,
    ConfirmDialog
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class ListPenunjangLain extends Vue {
  @Prop() dataOrder!: Array<object>;
  @Prop() type!: string;
  @Prop() showdetail!: boolean;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }
  tab = "buat-order";
  modalBatalOrder = false;
  idOrder = "";
  selectedDetail = null;
  showEdit = true;
  // dtpenunjanglain: PenunjangLainItem;
  dtpenunjanglain = {};
  dtfile;
  showFile = false;
  zoom = false;
  itemToBeDeleted: object;
  activeId = "";
  // file
  mounted() {
    // this.dtpenunjanglain:PenunjangLainItem
  }
  get stateUser() {
    return userModule.user;
  }

  get statepenunjanglain() {
    return storePenunjang.penunjanglain;
  }

  get canDeleteItem() {
    if (this.readOnly) return false;
    return (
      this.dtpenunjanglain &&
      [
        parseInt(this.dtpenunjanglain["user"].id),
        parseInt(this.dtpenunjanglain["dokter"].id)
      ].includes(this.stateUser.id)
    );
  }

  showImageDivider(index, files) {
    return files.length > 0 && index < files.length - 1;
  }

  @Watch("showdetail")
  changed() {
    if (this.showdetail == false) {
      this.showFile = false;

      // this.dtpenunjanglain = null;
      this.activeId = "";
    }
  }

  buatOrder() {
    this.$emit("pageTab", this.tab);
  }

  getHumanDate(date) {
    return date ? moment(date).format("DD MMMM YYYY") : "";
  }
  getHumanDateTime(date) {
    return date ? moment(date).format("DD MMMM YYYY HH:mm") : "";
  }
  getPenunjangLain(itemall) {
    this.dtpenunjanglain = itemall;
    this.activeId = itemall.id;

    this.showFile = true;
  }
  openDialog(v) {
    this.zoom = true;
    this.dtfile = v;
    // alert("aa");
  }
  pdfZoom(v) {
    this.zoom = true;
    this.dtfile = v;
  }

  deleteItem(data) {
    if (this.readOnly) return;
    this.modalOpenKonfirmasi = !this.modalOpenKonfirmasi;
    this.msgConfirm = "Anda yakin mau menghapus?";

    this.itemToBeDeleted = data;
  }

  modalOpenKonfirmasi = false;
  msgConfirm = "";

  dialogConfirmed() {
    if (this.readOnly) return;
    storePenunjang.delete_penunjang_lain_item(this.itemToBeDeleted);
    this.showFile = false;
  }

  dialogCanceled() {
    this.itemToBeDeleted = {};
  }
}
